import { useEffect, useState } from 'react';
import {
  getCandidateEmailLogsByCandidateId,
  ICandidateEmailLog,
  ICandidateEmailLogPayload,
  IPaginationAPIResponse,
} from 'wisestep-api';

const useCandidateEmailLogs = (search: ICandidateEmailLogPayload) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [candidateUniqueEmailLogs, setCandidateUniqueEmailLogs] = useState<
    IPaginationAPIResponse<ICandidateEmailLog>
  >({} as IPaginationAPIResponse<ICandidateEmailLog>);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await getCandidateEmailLogsByCandidateId(search);
        if (data) {
          setCandidateUniqueEmailLogs(data);
        }
      } catch (e) {
        console.error('Error while getting the Candidate Email Unique list', e);
      } finally {
        setLoading(false);
      }
    })();
  }, [search]);

  return { candidateUniqueEmailLogs, loading };
};

export default useCandidateEmailLogs;
